import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deploy/apps/front/src/components/auth/Register.tsx");
